import axios from 'axios'

// TEMPLATE ------------
const template = `<a href="{{url}}" class="story-card">
  <div class="story-card_img">
    <img src="{{img}}" alt="{{title}}" />
  </div>
  <div class="story-card_content">
      <p class="story-card_date tagline">{{categories}}</p>
      <h3 class="">{{title}}</h3>
  </div>
</a>`

const page = document.querySelector('[js-filter-list]')
const btn = document.querySelector('[js-filter-custom-btn]')
const list = document.querySelector('[js-filter-custom-list]') 
const select = document.querySelector('[js-filter-select]')
const reset = document.querySelector('[js-filter-reset]')

const state = {
  isOpen: false,
  value: '',
}

const baseUrl = document.querySelector('[js-api-url]').dataset.uri

if (page) {
  const defaultLabel = btn.querySelector('span').innerHTML

  // Open custom
  btn.addEventListener('click', () => {
    state.isOpen = !state.isOpen
    if (state.isOpen) list.classList.add('isOpen')
    else list.classList.remove('isOpen')
  })

  // Reset filter ------------ 
  reset.addEventListener('click', () => {
    state.value = ''
    if (list.querySelector('li.isActive')) list.querySelector('li.isActive').classList.remove('isActive')

    reset.style.opacity = 0
    reset.style.visibility = 'hidden'
    btn.querySelector('span').innerHTML = defaultLabel

    filterArticle()
  })


  // Custom select
  const items = list.querySelectorAll('li')
  for(const item of items) {
    item.addEventListener('click', () => {
      // Update State
      state.value = item.dataset.value
      state.isOpen = false
      list.classList.remove('isOpen')

      btn.querySelector('span').innerHTML = item.innerHTML

      // Active 
      if (list.querySelector('li.isActive')) list.querySelector('li.isActive').classList.remove('isActive')
      item.classList.add('isActive')

      reset.style.opacity = 1
      reset.style.visibility = 'visible'
      // FILTER
      filterArticle()
    })
  }

  select.addEventListener('change', () => {
    state.value = select.value

    if (select.value !== '') {
      reset.style.opacity = 1
      reset.style.visibility = 'visible'
    } else {
      reset.style.opacity = 0
      reset.style.visibility = 'hidden'
    }

    filterArticle()
  })
}

async function filterArticle() {
  // const type = ''
  const args = {
    per_page: 100,
    status: 'publish',
  }

  if (state.value !== '') args.categories = state.value

  page.style.opacity = 0
  page.style.transform = `translateY(50px)`

  const params = new URLSearchParams(args).toString()
  const items = await axios.get(`${baseUrl}/wp-json/wp/v2/policy?${params}`)

  setTimeout(() => {
    page.innerHTML = items.data.map((item) => {
      let nTemplate = template
      nTemplate = nTemplate.replace('{{categories}}', item.categories_format)
      nTemplate = nTemplate.replaceAll('{{title}}', item.title.rendered, 'g')
      nTemplate = nTemplate.replace('{{img}}', item.featured_image_src)
      nTemplate = nTemplate.replace('{{url}}', item.link)
      return nTemplate
    }).join('')

    page.style.opacity = 1
    page.style.transform = `translateY(0)`
  }, 1000)
}
